module.exports = __webpack_public_path__ + "img/door-open.7af067d9.svg";